import { IconButton } from "@mui/material";
import "./header.css";
import logo from "../../assets/images/Cadabams-Logo.png";

import React from "react";

const Header = () => {
  return (
    <header className="header">
      <IconButton color="primary">
        <img src={logo} alt="Cadabams logo" />
      </IconButton>
      {process.env.NODE_ENV === "development" ? (
        <span className="env-tag">development</span>
      ) : (
        ""
      )}
    </header>
  );
};

export default Header;
